import { SentryErrorBoundary } from './sentryUtils';

import { createRoot } from 'react-dom/client';
import { HashRouter as Router } from 'react-router-dom';

import injectGoogleTagManager from './injectGoogleTagManager';
import App from './components/App';
import './styles/global.css';

declare global {
  interface Window {
    dataLayer: unknown[];
    TMF_CONFIG?: {
      embedded: boolean;
      locale: 'es' | 'en';
    };
    DocumentTouch?: unknown;
  }
}

injectGoogleTagManager(import.meta.env.VITE_FISHBRAIN_GOOGLE_TAG_MANAGER_ID);
injectGoogleTagManager(import.meta.env.VITE_RBFF_GOOGLE_TAG_MANAGER_ID);

const root = createRoot(document.getElementById('root')!);
root.render(
  <SentryErrorBoundary>
    <Router>
      <App />
    </Router>
  </SentryErrorBoundary>,
);
